import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import authReducer from './auth';
import profileReducer from './profile';
import entitiesReducer from './entities';
import paginationReducer from './pagination';
import errorReducer from './error';
import filtersReducer from './filters';
import sortingReducer from './sorting';

const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  authenticated: authReducer,
  profile: profileReducer,
  entities: entitiesReducer,
  pagination: paginationReducer,
  error: errorReducer,
  filters: filtersReducer,
  sorting: sortingReducer,
});

export default rootReducer;
